import {invalidateQueries, q} from "../../state";
import {GetGraphQuery, GraphOperation} from "platformed-client/types";
import {platformedClient} from "..";

export async function get(query: GetGraphQuery) {
  return await platformedClient.internalRequest("get", `/region/{region}/api/vendor_toolkit/graph`, {query});
}

export async function update(operations: GraphOperation[]) {
  const res = await platformedClient.internalRequest("post", `/region/{region}/api/vendor_toolkit/graph`, {
    body: operations,
  });
  await invalidateQueries([q.vendorToolkit.graph.filter()]);
  return res;
}
